import NotificationService from "../external/ensolvers-core-frontend-mui/submodules/fox-typescript/services/NotificationService";
import Position from "../models/Position";
import WorkLog from "../models/WorkLog";
import Worklog from "../models/WorkLog";
import AssignationService from "../services/AssignationService";
import WorkLogService from "../services/WorkLogService";

export const MAX_HOURS_ADJUST = 8;
export const MAX_AUTOMATIC_HOURS_ADJUST = 4;
export const HOURS_ADJUST = 1;

export default interface WorkLogsMissingHours {
  missingHours: number;
  hoursPerDay: number;
  rest: number;
}

export interface WorkLogsAdjusterResponse {
  hours: number;
  errors: String[];
  hoursRemaining: number;
}

export default class WorklogsUtils {
  public static calculateMissingHoursPerDay = (hours: number, totalDays: number): WorkLogsMissingHours => {
    const hoursPerDay = Math.floor(hours / totalDays);
    const rest = hours % totalDays;

    const WorkLogsMissingHours: WorkLogsMissingHours = {
      missingHours: hours,
      hoursPerDay: hoursPerDay,
      rest: rest,
    };

    return WorkLogsMissingHours;
  };

  public static filterAdjustableWorklogs = (worklogs: Worklog[], position: Position): Worklog[] => {
    return worklogs.filter((worklog) => this.worklogIsAdjustable(worklog, position));
  };

  public static worklogIsAdjustable = (worklog: Worklog, position: Position): boolean => {
    const workedDay = worklog.hours > 0;
    const adjustableWorklog = worklog.adjustmentHours < MAX_AUTOMATIC_HOURS_ADJUST;
    const availableHours = worklog.hours + worklog.adjustmentHours < position.externalHours + MAX_AUTOMATIC_HOURS_ADJUST;
    const consistentHours = worklog.hours <= position.externalHours && worklog.internalHours <= position.internalHours;

    return workedDay && adjustableWorklog && availableHours && consistentHours;
  };

  public static filterWorklogsWithHours = (worklogs: Worklog[]): Worklog[] => {
    return worklogs.filter((worklog) => worklog.hours > 0);
  };

  public static getPositionForWorklog = async (assignationExternalId: string) => {
    const response = await AssignationService.getByExternalId(assignationExternalId);
    const position = response.getContent().position;
    return position;
  };

  public static getInternalReport = (workLog: WorkLog) => {
    console.log(workLog);
    
    return `Daily Report:
       \u2022 Summary: ${!!workLog.internalDescription ? workLog.internalDescription : workLog.description} 
       \u2022 Blockers: ${!workLog.details?.blockers?.length ? "-" : "\n\t\t\u2022 " + workLog.details?.blockers.join("\n\t\t\u2022 ")} 
       \u2022 Finished: ${!workLog.details?.tasksDone?.length ? "-" : "\n\t\t\u2022 " + workLog.details?.tasksDone.join("\n\t\t\u2022 ")}
       \u2022 WIP: ${
         !workLog.details?.tasksInProgress?.length ? "-" : "\n\t\t\u2022 " + workLog.details?.tasksInProgress.join("\n\t\t\u2022 ")
       } 
       \u2022 PRs Pending: ${
         !workLog.details?.prsPending?.length ? "-" : "\n\t\t\u2022 " + workLog.details?.prsPending.join("\n\t\t\u2022 ")
       }
       \u2022 Reported issues: ${
         !workLog.details?.reportedIssues?.length ? "-" : "\n\t\t\u2022 " + workLog.details?.reportedIssues.join("\n\t\t\u2022 ")
       }
       \u2022 Resolved issues: ${
         !workLog.details?.resolvedIssues?.length ? "-" : "\n\t\t\u2022 " + workLog.details?.resolvedIssues.join("\n\t\t\u2022 ")
       }
       \u2022 Hours: ${workLog.internalHours || "-"}`;
  };

  public static getExternalReport = async (workLog: WorkLog) => {
    if (!workLog || !workLog.externalId) {
      NotificationService.error("The report cannot be generated, since it does not have an associated worklog.");
      return;
    }

    try {
      const worklogReport = (await WorkLogService.getWorklogExternalReport(workLog.externalId)).getContent();

      if (worklogReport.lastWorkingDaySummary === "") {
        return `Status:
           \u2022 Today: ${worklogReport.description}`;
      } else {
        return `Status:
           \u2022 ${worklogReport.lastWorkingDay}: ${worklogReport.lastWorkingDaySummary}
           \u2022 Today: ${worklogReport.description}`;
      }
    } catch (error) {
      NotificationService.error("An error occurred while trying to generate the external report.");
    }
  };

  public static getWorklogDetails = (worklog: WorkLog): string[] => {
    const details = worklog?.details;

    if (details) {
      const detailsArray: string[] = [];

      const pushDetailToArray = (description: string, value?: number): void => {
        if (value && value > 0) {
          detailsArray.push(`${description}: ${value}`);
        }
      };

      pushDetailToArray("PR", details?.prsPending?.length);
      pushDetailToArray("DONE", details?.tasksDone?.length);
      pushDetailToArray("WIP", details?.tasksInProgress?.length);
      pushDetailToArray("B", details?.blockers?.length);
      pushDetailToArray("I", details?.reportedIssues?.length);
      pushDetailToArray("R", details?.resolvedIssues?.length);

      return detailsArray;
    }
    return [];
  };
}
